import './App.css'
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import {Menu} from './components/common/Menu'
import { injectStore } from './rest/http';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from './components/common/ToastContainer';

// Inject Redux store into HTTP client for 401 handling
injectStore(store);




function App() {
  return (
    <Provider store={store}>
      <ToastProvider>
        <BrowserRouter>
          <Menu/>
          <ToastContainer />
        </BrowserRouter>
      </ToastProvider>
    </Provider >
  );
}
export default App;
